import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import { validatorDependenteSemValorAdicional,
    validatorAte64Anos,
    validatorMaiorIgual65Anos,
    validatorDependenteSemValorAdicionalObrigatorio,
    validatorParentescosComRegrasEspeciaisAte64,
    validatorDependentesComAdicionalElegivelMaiorIgual65,
    validatorDependentesComAdicionalElegivelAte64,
    validatorParentescosComRegrasEspeciaisMaiorIgual65 } from './funcoesAuxiliaresZFT';

export class CorrenteCadastroZFT {
    constructor(dependentes, parentesco, categorias,valoresForm,isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
    }

    possui14Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais=== 14) {
            this.arrayMsgsErro.push('Este plano permite apenas 14 dependentes.');
        }

        return this;
    }

    parentescosSemValorAdicional() {
        if (validatorDependenteSemValorAdicional(this.valoresForm)) {
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    parentescosSemValorAdicionalRegrasEspeciais(){
        if(validatorDependenteSemValorAdicionalObrigatorio(this.valoresForm, this.dependentes)){
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    parentescoComAdicionalAte64(){
        if(validatorAte64Anos(this.valoresForm)){
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) até 64 anos, o adicional permitido é o ZELO FAMILIAR TROCA ATÉ 64.');
        }

        return this;
    }

    parentescoComAdicionalMaiorIgual65(){
        if(validatorMaiorIgual65Anos(this.valoresForm)){
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 65 anos, o adicional permitido é o ZELO FAMILIAR TROCA MAIS 65.');
        }

        return this;
    }

    paiComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '01' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes,  this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padastro sem adicional, ou Pai, e queira adicionar um dependente do tipo Pai até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    paiComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '01' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes,  this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padastro sem adicional, ou Pai, e queira adicionar um dependente do tipo Pai acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    maeComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '02' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes,  this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta sem adicional, ou Mãe, e queira adicionar um dependente do tipo Mãe até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    maeComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '02' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes,  this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '10' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge sem valor adicional, ou outro conjuge já cadastrado, e queira adicionar um dependente do tipo Esposo(A) até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '10' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '32' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '32' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '20007' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Mãe, ou Madrasta sem adicional, e queira adicionar um dependente do tipo MADRASTA até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '20007' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Mãe, ou Madrasta sem adicional, e queira adicionar um dependente do tipo MADRASTA acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalAte64(){
        if(this.valoresForm.Parentesco === '20008' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo tipo Padastro sem adicional, ou Pai, e queira adicionar um dependente do tipo PADRASTO até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalMaiorIgual65(){
        if(this.valoresForm.Parentesco === '20008' && validatorParentescosComRegrasEspeciaisMaiorIgual65(this.valoresForm, this.dependentes, this.editar)){
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo tipo Padastro sem adicional, ou Pai, e queira adicionar um dependente do tipo PADRASTO acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte64(){
        if(validatorDependentesComAdicionalElegivelAte64(this.valoresForm, this.dependentes)){
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro até 64 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO FAMILIAR TROCA ATÉ 64.');
        }

        return this;
    }

    parentescosComAdicionalElegivelMaiorIgual65(){
        if(validatorDependentesComAdicionalElegivelMaiorIgual65(this.valoresForm, this.dependentes)){
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro acima de 65 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO FAMILIAR TROCA MAIS 65.');
        }

        return this;
    }

    excecaoPetPorLocalidade(){
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(),this.valoresForm.Parentesco.trim())){
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet(){
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())){
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }
}
